/* eslint-disable react/prop-types */
import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const Message = ({ message }) => (
  <div className={`ai-chat-widget-message ${message.role}`}>
    {message.role === 'assistant' && (
      <AutoAwesomeIcon className="message-icon" fontSize="small" />
    )}
    <div className="message-content">{message.content}</div>
  </div>
);

export default Message;

